import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";

import "./map.css"
import {
  GoogleMap,
  useJsApiLoader,
  Autocomplete,
  Marker,
} from "@react-google-maps/api";

const MAPAPI = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const containerStyle = {
  width: "100%",
  height: "350px",
  borderRadius: "16px",
};

const MapComponent = ({ center, setCenter, fixed = false ,searchCity= "", locationName, setLocationName }) => {
  const [autocomplete, setAutocomplete] = useState(null);
  const [markerPosition, setMarkerPosition] = useState(center);
  console.log("Initial locationName:", locationName);
  const [inputValue, setInputValue] = useState(locationName || "");
  const geocoder = useRef(null);
  const { t } = useTranslation("addvenue");

  // Function to clean up address format
  const formatAddress = (address) => {
    if (!address) return "";
    
    // Remove postal codes (5 digits) and initial reference codes
    let cleanAddress = address
      // Remove postal codes (5 digits at the end before country)
      .replace(/\s+\d{5}(?=,\s*[^,]*$)/, '')
      // Remove initial codes like "RHWA6173، 6173" or similar patterns
      .replace(/^[A-Z0-9]+\d+،?\s*\d*\s*/, '')
      // Clean up any double commas or spaces
      .replace(/،\s*،/g, '،')
      .replace(/,\s*,/g, ',')
      .replace(/\s+/g, ' ')
      // Remove leading commas or Arabic commas
      .replace(/^[،,]\s*/, '')
      .trim();
    
    return cleanAddress;
  };

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: MAPAPI,
    libraries: ["places"],
  });

  useEffect(() => {
       if (geocoder.current && searchCity) {
        console.log("Geocoding input value:", searchCity);
        geocoder.current.geocode({ address: searchCity }, (results, status) => {
          if (status === "OK" && results[0]) {
            const loc = results[0].geometry.location;
            const newCenter = { lat: loc.lat(), lng: loc.lng() };
            setCenter(newCenter);
            setMarkerPosition(newCenter);
            const formattedAddress = formatAddress(results[0].formatted_address);
            setInputValue(formattedAddress);
            // Update location name when searchCity changes
            if (setLocationName) {
              setLocationName(formattedAddress);
            }
          } else {
            console.error("Geocode failed:", status);
          }
        });
      }

  }, [searchCity]);

  useEffect(() => {
    if (isLoaded && !geocoder.current) {
      geocoder.current = new window.google.maps.Geocoder();
    }
  }, [isLoaded]);

  useEffect(() => {
    setMarkerPosition(center);
  }, [center]);

  const onLoadAuto = (auto) => {
    setAutocomplete(auto);
  };

  const onPlaceChanged = () => {
    if (fixed || !autocomplete) return;
    const place = autocomplete.getPlace();
    if (!place.geometry || !place.geometry.location) {
      console.warn(
        "Selected place has no geometry. Please choose a suggestion."
      );
      return;
    }
    const loc = place.geometry.location;
    const newCenter = { lat: loc.lat(), lng: loc.lng() };
    setCenter(newCenter);
    setMarkerPosition(newCenter);
    const formattedAddress = formatAddress(place.formatted_address || "");
    setInputValue(formattedAddress);
    if (setLocationName) {
      setLocationName(formattedAddress);
    }
  };

  const onInputKeyDown = (e) => {
    if (fixed) return;
    if (e.key === "Enter") {
      e.preventDefault();
      if (autocomplete) {
        const place = autocomplete.getPlace();
        if (place && place.geometry) {
          onPlaceChanged();
          return;
        }
      }
      if (geocoder.current && inputValue) {
        console.log("Geocoding input value:", inputValue);
        geocoder.current.geocode({ address: inputValue }, (results, status) => {
          if (status === "OK" && results[0]) {
            const loc = results[0].geometry.location;
            const newCenter = { lat: loc.lat(), lng: loc.lng() };
            setCenter(newCenter);
            setMarkerPosition(newCenter);
            const formattedAddress = formatAddress(results[0].formatted_address);
            setInputValue(formattedAddress);
            setLocationName(formattedAddress);
          } else {
            console.error("Geocode failed:", status);
          }
        });
      }
    }
  };

    const handleMapClick = async (event) => {
    if (fixed) return;
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    const newPosition = { lat, lng };
    setCenter(newPosition);
    setMarkerPosition(newPosition);

    // Reverse geocode to get address
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: newPosition }, (results, status) => {
      if (status === "OK" && results[0]) {
        const formattedAddress = formatAddress(results[0].formatted_address);
        setInputValue(formattedAddress);
        if (setLocationName) {
          setLocationName(formattedAddress);
        }
      }
    });
  };

  if (loadError) return <div>Error loading maps</div>;
  if (!isLoaded) return <div>Loading map…</div>;

  return (
    <div style={{ width: "100%", height: "100%" }}>
      {!fixed && (
        <>
          <h5 className="label-map">{t("locationOnMap")}</h5>
          <div >
            <Autocomplete
              onLoad={onLoadAuto}
              onPlaceChanged={onPlaceChanged}
              options={{ fields: ["geometry", "formatted_address"] }}
            >
              <input
                placeholder={t("searchForLocation")}
                type="text"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={onInputKeyDown}
                className="input-map"
                style={{
                  // width: "100%",
                  padding: "8px",
                  borderRadius: "4px",
                  // border: "1px solid #ccc",
                }}
              />
            </Autocomplete>
          </div>
        </>
      )}
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={15}
        options={{
          zoomControl: false,
          fullscreenControl: false,
        }}
        onClick={handleMapClick}
      >
        <Marker position={markerPosition} />
      </GoogleMap>
    </div>
  );
};

export default MapComponent;
